export const PRIMARY = 'PRIMARY';
export const SECONDARY = 'SECONDARY';
export const ALL = 'ALL';